import { OnChanges, Component, Input, Output, EventEmitter } from '@angular/core';
import { DistributorParams } from 'src/app/models/shared-dto';
import { AnimationActionService } from 'src/app/services/animation-action.service';
import Swal from 'sweetalert2';
import { RenaultAnimationActionDetailDTO, RenaultAnimationActionDetailSupervisorDTO, RenaultAnimationActionResultFilterDTO, RenaultAnimationActionResultModel, RenaultAnimationSubactionResultModel } from '../../../models/renault-animation-action-dto';
import { saveAs } from 'file-saver';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AnimationActionGoalMatrixComponent } from '../animation-action-goal-matrix/animation-action-goal-matrix.component';
import { AnimationActionGoalGlobalMatrixComponent } from '../animation-action-goal-global-matrix/animation-action-goal-global-matrix.component';
import { style } from '@angular/animations';

@Component({
  selector: 'animation-action-global-result-card',
  templateUrl: './animation-action-global-result-card.component.html',
  styleUrls: ['./animation-action-global-result-card.component.scss']
})
export class AnimationActionGlobalResultCardComponent implements OnChanges {

  @Input() model: RenaultAnimationActionDetailDTO;
  @Input() distributorFiltersString: string;
  @Input() showManagers = false;
  @Input() showDownloadLink = true;
  @Input() renaultZone = false;
  @Output() remuneration = new EventEmitter<number>();
  distributorFilters: DistributorParams = new DistributorParams();
  modelSupervisor: RenaultAnimationActionDetailSupervisorDTO[];
  resultAction: RenaultAnimationActionResultModel;
  loading = false;


  constructor(private service: AnimationActionService, private modalService: NgbModal) { }

  ngOnChanges() {
    if (this.distributorFiltersString) {
      this.distributorFilters = JSON.parse(this.distributorFiltersString);
      this.getActionResult();
    }
  }

  ngAfterViewInit() {
    this.equalCardBodyHeight();
  }

  getActionResult() {
    const filters: RenaultAnimationActionResultFilterDTO = {
      DistributorFilters: this.distributorFilters,
      IdAction: this.model.IdAction,

    };

    this.loading = true;
    this.service.getAnimationActionResult(filters).subscribe(resp => {
      this.modelSupervisor = resp;
      // console.log(resp);
      this.calculateActionResult();
      this.loading = false;
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

  calculateActionResult() {
    const that = this;
    this.resultAction = {
      Title: this.model.Title,
      TotalRemuneration: 0,
      Subactions: []
    };
    this.modelSupervisor.forEach(function (actionSupervisor) {
      actionSupervisor.RenaultAnimationSubactions.forEach(function (subaction) {

        if (!that.resultAction.Subactions.some(x => x.Title == subaction.Title)) {
          let subactionResult: RenaultAnimationSubactionResultModel = {
            Title: subaction.Title,
            TotalRemuneration: 0,
            TotalUnits: 0
          };
          that.resultAction.Subactions.push(subactionResult);
        }

        that.resultAction.TotalRemuneration += subaction.TotalPrice;
        let subactionResult = that.resultAction.Subactions.find(x => x.Title == subaction.Title);
        subactionResult.TotalRemuneration += subaction.TotalPrice;
      });

      actionSupervisor.RenaultAnimationSubactionsUser.forEach(function (subactionUser) {
        that.resultAction.TotalRemuneration += subactionUser.SoldTotalPrice;
        let subactionResult = that.resultAction.Subactions.find(x => x.Title == subactionUser.Title);
        subactionResult.TotalRemuneration += subactionUser.SoldTotalPrice;
        subactionResult.TotalUnits += subactionUser.SoldUnits;
      });

    });
    that.remuneration.emit(that.resultAction.TotalRemuneration);
    if (this.modelSupervisor.length == 0)
      that.remuneration.emit(0);
  }

  downloadExcel(idAction: string) {

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...'
    });
    Swal.showLoading();

    var data: string[] = [];
    data.push(idAction);

    this.service.getAnimationActionExcel(data).subscribe(blob => {
      Swal.close();
      saveAs(blob, "MyPosventa_EstadisticasAnimacionRed.xlsx");
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al acceder a la BD',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

  viewActionGoalMatrix() {

    if (!this.renaultZone) {
      const modalRef = this.modalService.open(AnimationActionGoalMatrixComponent, { size: 'lg', centered: true });
      modalRef.componentInstance.idAction = this.model.IdAction;
      modalRef.componentInstance.idPpvGroup = this.distributorFilters.PvGroup[0];
    } else {
      const modalRef = this.modalService.open(AnimationActionGoalGlobalMatrixComponent, { size: 'xl', centered: true });
      modalRef.componentInstance.idAction = this.model.IdAction;
    }

  }

  equalCardBodyHeight() {
    let resultCardsTitle = document.querySelectorAll('.global-result-card-container .card-title');
    let minValue = 0;

    resultCardsTitle.forEach(cardTitle => {
      if(cardTitle.clientHeight > minValue) {
        minValue = cardTitle.clientHeight;
      }
    });

    resultCardsTitle.forEach(cardTitle => {
      let cardTitleHTMlel = cardTitle as HTMLElement;
      cardTitleHTMlel.style.setProperty('min-height', minValue + 'px');
      // console.log('card parent row:' + minValue);
    });
  }

}
